<template>
  <v-card flat v-if="user && user.is_active">
    <v-card-title>
      {{ $t("home.title") }}
      <v-spacer />
      <v-btn
        v-if="user.is_dr"
        color="color_action"
        @click="send()"
        :disabled="sendRelanceIsLoading"
      >
        <v-icon left dark> mdi-send</v-icon>
        {{ $t("btn.send") }}
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-data-table
          checkbox-color="indigo"
          v-model="selected"
          :headers="ligneHeaders"
          :items="ligneRobComs"
          item-key="id"
          :search="search"
          @dblclick:row="open"
          show-select
        >
          <template #top="">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Rechercher"
              single-line
              hide-details
              clearable
              class="mb-4 ml-5"
            />
          </template>
          <template #[`item.valeur_devise_origine`]="{ item }">
            {{ item.valeur_devise_origine }}
          </template>
          <template #[`item.statut`]="{ item }">
            <v-icon v-if="item.statut" color="color_success">
              mdi-check-circle-outline
            </v-icon>
            <v-icon v-else color="color_danger"> mdi-alert-outline</v-icon>
          </template>
          <template #[`item.facturette`]="{ item }">
            <v-icon v-if="item.facturette" color="color_success">
              mdi-check-circle-outline
            </v-icon>
            <template v-else>
              <v-icon color="color_danger"> mdi-alert-outline</v-icon>
            </template>
          </template>
          <template #[`item.relance`]="{ item }">
            <v-icon v-if="item.relance === 'DR'" color="color_primary">
              mdi-check-circle-outline
            </v-icon>
          </template>
          <template #[`item.carte.nom`]="{ item }">
            {{ item.carte.nom }} {{ item.carte.prenom }}
          </template>
        </v-data-table>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { ligneRobComMixin } from "@/mixins/ligneRobCom";
import { userMixin } from "@/mixins/user";
import { relanceMixin } from "@/mixins/relance";
import { tvaMixin } from "@/mixins/tva";

export default {
  name: "homeCom",
  mixins: [ligneRobComMixin, userMixin, relanceMixin, tvaMixin],
  data() {
    return {
      search: "",
      selected: [],
    };
  },
  computed: {
    ligneHeaders() {
      let a = [
        {
          text: this.$t("ligneRob.statut"),
          align: "start",
          sortable: true,
          value: "statut",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("ligneRob.facturette"),
          align: "start",
          sortable: true,
          value: "facturette",
          class: "color_thead lighten-2  white--text",
        },
        {
          text: this.$t("ligneRob.num"),
          align: "start",
          sortable: true,
          value: "num",
          class: "color_thead lighten-2  white--text",
        },
        {
          text: this.$t("ligneRob.date_emission"),
          align: "start",
          sortable: true,
          value: "date_emission",
          class: "color_thead lighten-2  white--text",
        },
        {
          text: this.$t("ligneRob.type"),
          align: "start",
          sortable: true,
          value: "type",
          class: "color_thead lighten-2  white--text",
        },
        {
          text: this.$t("ligneRob.montantTTC"),
          align: "start",
          sortable: true,
          value: "montant_ttc",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("ligneRob.fournisseur"),
          align: "start",
          sortable: true,
          value: "fournisseur",
          class: "color_thead lighten-2 white--text",
        },
        {
          text: this.$t("ligneRob.carte"),
          align: "start",
          sortable: true,
          value: "carte.nom",
          class: "color_thead lighten-2 white--text",
        },
        {
          text: this.$t("ligneRob.montantDeviseOrigine"),
          align: "start",
          sortable: true,
          value: "valeur_devise_origine",
          class: "color_thead lighten-2 white--text",
        },
        {
          text: this.$t("ligneRob.structure"),
          align: "start",
          sortable: true,
          value: "structure",
          class: "color_thead lighten-2 white--text",
        },
      ];
      if (this.user !== null && this.user.is_dr)
        a.push({
          text: this.$t("ligneRob.relance"),
          align: "start",
          sortable: true,
          value: "relance",
          class: "color_thead lighten-2 white--text",
        });
      return a;
    },
  },
  methods: {
    send() {
      const lineSend = this.selected.map((x) => x.id);
      if (lineSend.length > 0) {
        this.sendRelance({ lines: lineSend });
      }
    },
    open(evt, { item }) {
      this.$router.push({
        name: "rob",
        params: {
          rob: item.rob,
          structure: item.carte.structure,
          nomStructure: item.carte.nomStructure,
          centre_facturation: item.centre_facturation,
          carte: item.carte.id,
          ligne: item.id,
          nomCarte: item.carte.prenom + " " + item.carte.nom,
        },
      });
    },
  },
  mounted() {
    this.getligneRobComs();
  },
};
</script>

<style scoped></style>
